/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';

const MAX_RATING = 5;

export default class extends Component {
    render() {
        let rating = Math.round(this.props.rating) || 0;
        let llenas = new Array(rating).fill(0) || 0;
        let vacias = new Array(MAX_RATING - rating).fill(0) || 0;

        return (
            <ul className="poi-star-rating">
                {
                    llenas.map(function (obj, i) {
                        return (
                            <li key={`star${i}`}>
                                <i className="glyphicon glyphicon-star estrella-llena"></i>
                            </li>
                        )
                    })
                }
                {
                    vacias.map(function (obj, j) {
                        return (
                            <li key={`star-empty${j}`}>
                                <i className="glyphicon glyphicon-star-empty"></i>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PoiRating.js